import { useTranslation } from 'react-i18next'

function ErrorPage () {
  const { t } = useTranslation()

  return (
    <div className='text-white'>
      <h1 className='font-medium '>
        {t('errorPage_title')}
      </h1>
      <p className='py-4'>
        {window.location.search?.includes('message') ? new URLSearchParams(window.location.search).get('message') : t('errorPage_message')}
      </p>
    </div>
  )
}

export default ErrorPage
